function addZero(val) {
    return val < 10 ? '0' + val : val;
}

export default {
    methods: {
        dateTimeFormat(plainVal, isWithYear = true, isWithSeconds = false) {
            let date = new Date(plainVal);

            if (isNaN(date.getDay())) {
                return
            }

            if (isWithSeconds) {
                return this.dateFormatWithSeconds(isWithYear, date)
            }

            let res = '' +
                addZero(date.getHours()) + ':' +
                addZero(date.getMinutes()) + ', ' +
                addZero(date.getDate()) + '.' +
                addZero(date.getMonth() + 1);

            if (isWithYear) {
                res += '.' + date.getFullYear();
            }

            return res
        },
        timeFormat(plainVal) {
            let date = new Date(plainVal);

            if (isNaN(date.getDay())) {
                return
            }


            return addZero(date.getHours()) + ':' +
                addZero(date.getMinutes()) + ', '
        },
        dateFormat(plainVal, isWithYear = true) {
            let date = new Date(plainVal);

            let res = '' +
                addZero(date.getDate()) + '.' +
                addZero(date.getMonth() + 1);

            if (isWithYear) {
                res += '.' + date.getFullYear();
            }

            return res
        },
        dateFormatWithSeconds (isWithYear, date) {
            let res = '' +
                addZero(date.getHours()) + ':' +
                addZero(date.getMinutes()) + ':' +
                addZero(date.getSeconds()) + ', ' +
                addZero(date.getDate()) + '.' +
                addZero(date.getMonth() + 1);

            if (isWithYear) {
                res += '.' + date.getFullYear();
            }

            return res
        }
    }
}
